import { ThreeElements } from '@react-three/fiber';
import { useRef } from 'react';
import * as THREE from 'three';
import { ITuple3 } from '../../component-data-structure';
import { useBillboardObject3d } from './hooks';

interface IBillboardProps {
	follow?: boolean;
	lockY?: boolean;
    rotation?: ITuple3;
}

export type ICustomBillboardProps = IBillboardProps & Omit<ThreeElements['group'], 'ref' | 'rotation'>;

export const Billboard = (props: ICustomBillboardProps & {cancelParentYRotation?: boolean}) => {
	const groupRef = useRef<THREE.Group>(null);
	const { follow = false, lockY = false, children, rotation, cancelParentYRotation = true, ...groupProps } = props;

    useBillboardObject3d({object3d: groupRef, rotation, follow, lockY, cancelParentYRotation});

	return (
		<group ref={groupRef} {...groupProps}>
            <group>
                {children}
            </group>
		</group>
	);
};

export default Billboard;
